import Http from '../http';

const prefix = '/browser-notification';

export const auth = (id, language) => {
  return Http.authApi().post(`${prefix}/auth`, {id, language});
};

export const createBrowserNotif = (params) => {
  return Http.authApi().post(`${prefix}/register`, params);
};



// WEBPACK FOOTER //
// ./src/js/services/integrations-internas/browserNotification.js